"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectClass = exports.registerObjectClass = void 0;
const objectClassMap = new Map();
function registerObjectClass(objectClass, className, serialVersionUid) {
    let classMap = objectClassMap.get(className);
    if (!classMap) {
        classMap = new Map();
        objectClassMap.set(className, classMap);
    }
    const versionUid = BigInt(serialVersionUid);
    const existingClass = classMap.get(versionUid);
    if (existingClass === objectClass) {
        throw new Error("object class already registered");
    }
    classMap.set(versionUid, objectClass);
}
exports.registerObjectClass = registerObjectClass;
function getObjectClass(className, serialVersionUid) {
    const classMap = objectClassMap.get(className);
    if (!classMap) {
        return null;
    }
    const objectClass = classMap.get(serialVersionUid);
    if (!objectClass) {
        return null;
    }
    return objectClass;
}
exports.getObjectClass = getObjectClass;
